function initializeVariantItemEvents(container = document) {
    // console.log("Initializing variant item events...");
    
    const variantItems = container.querySelectorAll(".card__variant-item");

    variantItems.forEach(item => {
        if (!item.classList.contains("sold-out") && !item.dataset.initialized) {
            item.dataset.initialized = "true"; // prevent duplicate listeners

            item.addEventListener("click", () => {
                const list = item.closest(".jt-card__variants-list");
                if (!list) return;

                const siblings = list.querySelectorAll(".card__variant-item");

                siblings.forEach(sibling => {
                    sibling.classList.remove("selected");
                    sibling.setAttribute("aria-selected", "false");
                });

                item.classList.add("selected");
                item.setAttribute("aria-selected", "true");

                const variantId = item.getAttribute("data-variant-id");
                console.log("Selected variant ID:", variantId);

                const productCard = item.closest('.card-wrapper');
                if (productCard) {
                    const input = productCard.querySelector('input[name="id"]');
                    if (input) {
                        input.value = variantId;
                    }
                }
            });

            item.addEventListener("keydown", (e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    item.click();
                }
            });
        }
    });
}

function initialiseCoureSwatches() {
    const sliders = document.querySelectorAll('.productcardcolorimages');
    // document.querySelectorAll('.productsliderfun').forEach((el) => {
    //     el.addEventListener('click', () => {
    //         console.log('productsliderfun clicked');
            
    //         window.productsliderfun()
    //     });
    // });
    sliders.forEach((slider) => {
        const wrappers = slider.querySelectorAll('.product-slider-wrapper');
        const swiperInstances = [];

        // Initialize swiper for each image group
        wrappers.forEach((wrapper) => {
            let ele = wrapper.closest('.colorproductimage')
            swiperInstances.push(new Swiper(wrapper.closest('.colorproductimage'), {
                slidesPerView: 1,
                spaceBetween: 10,
                loop: true,
                navigation: {
                    nextEl: ele.querySelector('.swiper-button-next'),
                    prevEl: ele.querySelector('.swiper-button-prev'),
                },
                pagination: {
                    el: ele.querySelector('.swiper-pagination'),
                    clickable: true,
                },
            }));
        });
        // Example: swatch click simulation — replace with your actual swatch logic
        document.querySelectorAll('.swatch-button').forEach((swatch) => {
            swatch.addEventListener('click', function () {
                const targetUrl = this.dataset.productUrl;

                wrappers.forEach(wrapper => {
                    wrapper.classList.remove('active');
                    if (wrapper.dataset.productUrl === targetUrl) {
                        wrapper.classList.add('active');
                    }
                });
            });
        });
    });
}

document.addEventListener("DOMContentLoaded", function () {
    initializeVariantItemEvents();
    initialiseCoureSwatches();
});

function productsliderfun() {
    try {
        const element = document.querySelectorAll("li.grid__item.colorcard");
        // console.log('element', element);

        element.forEach((el) => {
            let sliderint = el.querySelector(".card-wrapper");
            if (!sliderint) return;
            let pid = sliderint.getAttribute('data-id');
            let pidActual = sliderint.getAttribute('data-product-id');
            // console.log('sliderint', pid);

            let colorslider = el.querySelector(".productcardcolorswatch");
            var contentm = document.getElementById('product_image_slide_container_' + pid + '');
            var maincolor = document.getElementById('productcardcolor_' + pid + '');
            // console.log("contentm", "maincolor");
            // console.log(contentm, maincolor);

            if (!maincolor || !contentm) {
                console.warn('Missing maincolor or contentm for pid:', pid);
                return;
            }

            let swatchcolorW = maincolor.querySelectorAll(".colorswatch");
            let productid_info = contentm.querySelectorAll(".colorproductimage");
            // console.log('swatchcolorW', swatchcolorW);

            swatchcolorW.forEach(function (swatchEl) {
                swatchEl.addEventListener('click', (e) => {
                    const et = e.target;
                    swatchcolorW.forEach(function (ell) {
                        if (swatchEl !== ell) {
                            ell.classList.remove('active');
                        }
                    });
                    et.classList.add('active');
                    let cardheading = document.getElementsByClassName('cardheading_' + pidActual + '');
                    let mainprice = document.getElementById('mainprice_' + pid + '');
                    let compareprice = document.getElementById('compareprice_' + pid + '');
                    // let discountprice = document.getElementById('discountprice_' + pid + '');
                    let swatchProductVariant = swatchEl.getAttribute('product-variants');
                    // console.log('swatchProductVariant', JSON.parse(swatchProductVariant));
                    
                    const productCard = swatchEl.closest('.jt-product-card__information');
                    // console.log('productCard', productCard);
                    
                    if (swatchProductVariant && productCard) {
                        const variantId = JSON.parse(swatchProductVariant)[0].id;
                        const prdVariant = JSON.parse(swatchProductVariant)?.filter((variant)=> variant.available);
                        const varianthtmls = prdVariant?.map((variant, index) => {
                            return `<span class="card__variant-item cc ${(index==0)? 'selected' : ""} ${!variant.available? 'sold-out': ""}" data-variant-id="${variant.id}" tabindex="0" role="option" aria-selected="${(index==0)}" aria-disabled="${variant.available}"><span class="jt-product__swatch-text">${ variant.option1 }</span></span>`
                        });
                        const input = productCard.querySelector('input[name="id"]');
                        if (input) {
                            input.value = variantId;
                        }

                        const variantList = productCard.querySelector('.jt-card__variants-list');
                        if (variantList) {
                            variantList.innerHTML = varianthtmls.join('');
                            initializeVariantItemEvents(variantList)
                        }
                    }
                    let head = productCard.querySelector('.card__heading a');
                    let price = productCard.querySelector('.price-item--regular')
                    head.textContent = swatchEl.getAttribute('product-title');
                    head.href = swatchEl.getAttribute('product-url');
                    price.innerHTML = swatchEl.getAttribute('product-price');
                    console.log('swatchEl.getAttribute("product-title")', productCard.querySelector('.card__heading a'));
                    
                    for (let content of productid_info) {
                        if (content.getAttribute('data-id') === swatchEl.getAttribute('data-id')) {
                            content.style.display = "block";
                            // console.log(cardheading);
                            if (cardheading) {
                                cardheading.innerHTML = content.getAttribute('product-title');
                                cardheading.href = content.getAttribute('product-url');
                            }
                            if (mainprice) {
                                mainprice.innerHTML = content.getAttribute('main-price');
                            }
                            if (compareprice) {
                                compareprice.innerHTML = content.getAttribute('compare-price');
                            }
                            // if (discountprice) {
                            //     discountprice.innerHTML = content.getAttribute('discount-price');
                            // }
                        } else {
                            content.style.display = "none";
                        }
                    }
                });
            });
            console.log('productsliderfun called');
        });

    } catch (err) {
        console.log('err', err)
    }
}
window.addEventListener(
    'DOMContentLoaded',
    () => {
        window.productsliderfun();
        window.initializeVariantItemEvents();
        window.initialiseCoureSwatches();
    });

// document.addEventListener("DOMContentLoaded", );

// document.addEventListener('DOMContentLoaded', function() {
//     const input = document.getElementById('product-search-input');
//     const productGrid = document.getElementById('product-grid');
//     const originalHTML = productGrid.innerHTML;
  
//     input.addEventListener('input', function () {
//       const query = this.value.trim();
  
//       if (query.length < 3) {
//         productGrid.innerHTML = originalHTML;
//         initializeVariantItemEvents();
//         return;
//       }
  
//       fetch(`/search?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=12&collection={{ collection.id }}&view=search-results`)
//       .then(response => response.text())
//       .then(html => {
//         // Parse the returned HTML
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(html, 'text/html');
    
//         // Adjust this selector based on your theme's product grid container
//         const items = doc.querySelectorAll('.product-grid .grid__item');
    
//         productGrid.innerHTML = '';
    
//         if (!items.length) {
//           productGrid.innerHTML = '<li>No products found.</li>';
//           return;
//         }
    
//         items.forEach(item => {
//           productGrid.appendChild(item);
//         });
//         initializeVariantItemEvents();
//       })
//       .catch(err => {
//         console.error('Search error:', err);
//       });  
//     });
//   });

// Price Range Slider
// document.addEventListener('DOMContentLoaded', function () {
//   const rangeMin = document.getElementById('rangeMin');
//   const rangeMax = document.getElementById('rangeMax');
//   const rangeFill = document.getElementById('slider-range-fill');
//   const inputMin = document.getElementById('inputMin');
//   const inputMax = document.getElementById('inputMax');
//   const displayMin = document.getElementById('rangeMinVal');
//   const displayMax = document.getElementById('rangeMaxVal');

//   const minGap = 1; // Optional: minimum gap between sliders

//   function updateSliderVisuals() {
//     let min = parseInt(rangeMin.value);
//     let max = parseInt(rangeMax.value);

//     const minAttr = parseInt(rangeMin.min);
//     const maxAttr = parseInt(rangeMax.max);

//     const percentMin = ((min - minAttr) / (maxAttr - minAttr)) * 100;
//     const percentMax = ((max - minAttr) / (maxAttr - minAttr)) * 100;

//     rangeFill.style.left = percentMin + '%';
//     rangeFill.style.width = (percentMax - percentMin) + '%';

//     displayMin.textContent = min.toLocaleString();
//     displayMax.textContent = max.toLocaleString();
//     inputMin.value = min;
//     inputMax.value = max;
//   }

//   function syncInputsToSlider(e, type = "") {
//     let min = (type === "min") ? parseInt(e.target.value) : parseInt(inputMin.value);
//     let max = (type === "max") ? parseInt(e.target.value) : parseInt(inputMax.value);

//     if (isNaN(min)) min = parseInt(rangeMin.min);
//     if (isNaN(max)) max = parseInt(rangeMax.max);

//     rangeMin.value = min;
//     rangeMax.value = max;
//     updateSliderVisuals();
//   }

//   function syncSlidersToInputs(e, type = "") {
//     let min = (type === "min") ? parseInt(e.target.value) : parseInt(rangeMin.value);
//     let max = (type === "max") ? parseInt(e.target.value) : parseInt(rangeMax.value);

//     if (max - min < minGap) {
//       if (e.target === rangeMin) {
//         rangeMin.value = max - minGap;
//       } else {
//         rangeMax.value = min + minGap;
//       }
//     }

//     inputMin.value = min;
//     inputMax.value = max;
//     updateSliderVisuals();
//   }

//   inputMin.addEventListener('change', function (e) { syncInputsToSlider(e, "min") });
//   inputMax.addEventListener('change', function (e) { syncInputsToSlider(e, "max") });

//   rangeMin.addEventListener('input', function (e) { syncSlidersToInputs(e, "min") });
//   rangeMax.addEventListener('input', function (e) { syncSlidersToInputs(e, "max") });

//   // Initial visual setup
//   updateSliderVisuals();
// });